<template>
  <div
    class="oil-section-container"
  >
    <div class="oil-section-title">
      RESET PROCEDURES
    </div>
    <div
      class="oil-section-sub-container"
      @click="onClickYoutube"
    >
      Engine Oil Life Indicator Reset
      <div
        class="center-button"
        :class="showOverlay ? 'button-animation overlay-button' : ''"
      >
        <img
          class="icon"
          id="yt-button"
          src="../assets/yt_icon_rgb.png"
          alt="Youtube"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OilResetButton',
  data() {
    return {
      showOverlay: false,
    };
  },
  methods: {
    onClickYoutube() {
      this.showOverlay = true;
      this.$native.send({
        event: 'youtube-button:play',
        name: 'Engine Oil Life Indicator Reset',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .oil-section-container {
    width: 95%;
    padding: 10px;
    .oil-section-sub-container {
      background-color: $surface-light;
      font-size: 15px;
      font-weight: bold;
      width: 100%;
      padding: 16px;
      box-sizing: border-box;
      border: 1px solid $borders;
      border-radius: 5px;
      display: flex;
      text-align: start;
      justify-content: space-between;
      .center-button {
        height: 20px;
        .icon {
          height: 20px;
          margin-left: auto;
        }
      }

      .button-animation {
        animation: gradient 3s infinite linear;
      }

      .overlay-button {
        opacity: 0.5;
        filter: grayscale(100%);
      }
    }
  }
  .oil-section-title {
    font-size: 1em;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 16px;
  }

</style>
